import AssociatedProgramsTable from './AssociatedProgramsTable';

export default AssociatedProgramsTable;
